// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/AuthorizationPolicy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file Enumerations/AuthorizationPolicy.proto.
 */
export const file_Enumerations_AuthorizationPolicy: GenFile = /*@__PURE__*/
  fileDesc("CiZFbnVtZXJhdGlvbnMvQXV0aG9yaXphdGlvblBvbGljeS5wcm90bxIadGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMqjwEKE0F1dGhvcml6YXRpb25Qb2xpY3kSJgoiQVVUSE9SSVpBVElPTl9QT0xJQ1lfQURNSU5JU1RSQVRPUhAAEh0KGUFVVEhPUklaQVRJT05fUE9MSUNZX1VTRVIQARIxCi1BVVRIT1JJWkFUSU9OX1BPTElDWV9VU0VSX1dJVEhfSURFTlRJRklDQVRJT04QAkIoqgIlTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLkVudW1lcmF0aW9uc2IGcHJvdG8z");

/**
 * Determines the ASP.net Core authorization policy to execute for a service method.
 *
 * @generated from enum time_tracking.enumerations.AuthorizationPolicy
 */
export enum AuthorizationPolicy {
  /**
   * Only administrators are allowed to call this service method.
   *
   * @generated from enum value: AUTHORIZATION_POLICY_ADMINISTRATOR = 0;
   */
  ADMINISTRATOR = 0,

  /**
   * Both administrators and users are allowed to call this service method.
   *
   * @generated from enum value: AUTHORIZATION_POLICY_USER = 1;
   */
  USER = 1,

  /**
   * Administrators can call this service method unrestricted, but users only when they are allowed
   * to access the referenced resource using their user ids.
   *
   * @generated from enum value: AUTHORIZATION_POLICY_USER_WITH_IDENTIFICATION = 2;
   */
  USER_WITH_IDENTIFICATION = 2,
}

/**
 * Describes the enum time_tracking.enumerations.AuthorizationPolicy.
 */
export const AuthorizationPolicySchema: GenEnum<AuthorizationPolicy> = /*@__PURE__*/
  enumDesc(file_Enumerations_AuthorizationPolicy, 0);

